import styled from 'styled-components';

export const BlockContainer = styled.div`
  margin: 0 1rem;

  @media (min-width: 932px) {
    max-width: 900px;
    margin: 0 auto;
  }

  @media (min-width: 1350px) {
    margin: 0 445px 0 auto;
  }

  @media (min-width: 1750px) {
    margin: 0 auto;
  }

  @media print {
    margin: 0 auto;
    padding: 0 1rem;
  }
`;
